import * as i0 from '@angular/core';
import * as i1 from './crnk.binding.module';
import * as i2 from '@angular/common';
import * as i3 from '@angular/forms';
import * as i4 from '../expression/forms/crnk.expression.form.model.default';
import * as i5 from '../expression/forms/crnk.expression.form.model.form';
import * as i6 from '../expression/forms/crnk.expression.form.model.accessor';
import * as i7 from '../expression/forms/crnk.expression.form.validators.base';
import * as i8 from '../expression/forms/crnk.expression.form.validators.jsonapi';
import * as i9 from './crnk.binding.error';
import * as i10 from 'ngrx-json-api';
import * as i11 from '../expression/forms/crnk.expression.form.module';
export const CrnkBindingModuleNgFactory:i0.NgModuleFactory<i1.CrnkBindingModule> = (null as any);
var _decl0_0:i2.NgClass = (<any>(null as any));
var _decl0_1:i2.NgComponentOutlet = (<any>(null as any));
var _decl0_2:i2.NgForOf<any> = (<any>(null as any));
var _decl0_3:i2.NgIf = (<any>(null as any));
var _decl0_4:i2.NgTemplateOutlet = (<any>(null as any));
var _decl0_5:i2.NgStyle = (<any>(null as any));
var _decl0_6:i2.NgSwitch = (<any>(null as any));
var _decl0_7:i2.NgSwitchCase = (<any>(null as any));
var _decl0_8:i2.NgSwitchDefault = (<any>(null as any));
var _decl0_9:i2.NgPlural = (<any>(null as any));
var _decl0_10:i2.NgPluralCase = (<any>(null as any));
var _decl0_11:i3.ɵbf = (<any>(null as any));
var _decl0_12:i3.NgSelectOption = (<any>(null as any));
var _decl0_13:i3.ɵq = (<any>(null as any));
var _decl0_14:i3.DefaultValueAccessor = (<any>(null as any));
var _decl0_15:i3.ɵbc = (<any>(null as any));
var _decl0_16:i3.ɵbe = (<any>(null as any));
var _decl0_17:i3.CheckboxControlValueAccessor = (<any>(null as any));
var _decl0_18:i3.SelectControlValueAccessor = (<any>(null as any));
var _decl0_19:i3.SelectMultipleControlValueAccessor = (<any>(null as any));
var _decl0_20:i3.RadioControlValueAccessor = (<any>(null as any));
var _decl0_21:i3.NgControlStatus = (<any>(null as any));
var _decl0_22:i3.NgControlStatusGroup = (<any>(null as any));
var _decl0_23:i3.RequiredValidator = (<any>(null as any));
var _decl0_24:i3.MinLengthValidator = (<any>(null as any));
var _decl0_25:i3.MaxLengthValidator = (<any>(null as any));
var _decl0_26:i3.PatternValidator = (<any>(null as any));
var _decl0_27:i3.CheckboxRequiredValidator = (<any>(null as any));
var _decl0_28:i3.EmailValidator = (<any>(null as any));
var _decl0_29:i3.NgModel = (<any>(null as any));
var _decl0_30:i3.NgModelGroup = (<any>(null as any));
var _decl0_31:i3.NgForm = (<any>(null as any));
var _decl0_32:i4.ExpressionDirective = (<any>(null as any));
var _decl0_33:i5.FormExpressionDirective = (<any>(null as any));
var _decl0_34:i6.ExpressionDefaultValueAccessorDirective = (<any>(null as any));
var _decl0_35:i7.ExpressionPatternValidatorDirective = (<any>(null as any));
var _decl0_36:i7.ExpressionMaxLengthValidatorDirective = (<any>(null as any));
var _decl0_37:i7.ExpressionMinLengthValidatorDirective = (<any>(null as any));
var _decl0_38:i7.ExpressionCheckboxRequiredValidatorDirective = (<any>(null as any));
var _decl0_39:i7.ExpressionRequiredValidatorDirective = (<any>(null as any));
var _decl0_40:i7.ExpressionEmailValidatorDirective = (<any>(null as any));
var _decl0_41:i8.ResourceValidatorDirective = (<any>(null as any));
var _decl0_42:i9.ControlErrorsComponent = (<any>(null as any));
var _decl0_43:i9.ResourceErrorsComponent = (<any>(null as any));
var _decl0_44:i2.AsyncPipe = (<any>(null as any));
var _decl0_45:i2.UpperCasePipe = (<any>(null as any));
var _decl0_46:i2.LowerCasePipe = (<any>(null as any));
var _decl0_47:i2.JsonPipe = (<any>(null as any));
var _decl0_48:i2.SlicePipe = (<any>(null as any));
var _decl0_49:i2.DecimalPipe = (<any>(null as any));
var _decl0_50:i2.PercentPipe = (<any>(null as any));
var _decl0_51:i2.TitleCasePipe = (<any>(null as any));
var _decl0_52:i2.CurrencyPipe = (<any>(null as any));
var _decl0_53:i2.DatePipe = (<any>(null as any));
var _decl0_54:i2.I18nPluralPipe = (<any>(null as any));
var _decl0_55:i2.I18nSelectPipe = (<any>(null as any));
var _decl0_56:i10.DenormaliseStoreResourcePipe = (<any>(null as any));
var _decl0_57:i10.GetDenormalisedValuePipe = (<any>(null as any));
var _decl0_58:i10.SelectStoreResourcePipe = (<any>(null as any));
var _decl0_62:i2.CommonModule = (<any>(null as any));
var _decl0_63:i10.NgrxJsonApiModule = (<any>(null as any));
var _decl0_64:i11.CrnkExpressionFormModule = (<any>(null as any));
var _decl0_65:i0.TemplateRef<any> = (<any>(null as any));
var _decl0_66:i0.ElementRef = (<any>(null as any));
function _View_ControlErrorsComponent_Host_1_0():void {
  var _any:any = (null as any);
}
function _View_ControlErrorsComponent_1_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_42.controlErrors;
  currVal_0;
}
function _View_ResourceErrorsComponent_Host_2_0():void {
  var _any:any = (null as any);
}
function _View_ResourceErrorsComponent_2_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_43.pathErrors;
  currVal_0;
}
